import { render, staticRenderFns } from "./VersionConfig.vue?vue&type=template&id=5eafc033&scoped=true"
import script from "./VersionConfig.vue?vue&type=script&lang=js"
export * from "./VersionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eafc033",
  null
  
)

export default component.exports